// extracted by mini-css-extract-plugin
export default {"dobInput":"NumericInput_dobInput__tPN1I","inputLabel":"NumericInput_inputLabel__ItCGV"};